import { StatusPill } from '../../dashboards/primitives/StatusPill';

const INACTIVE_STYLE = {
  height: 20,
  fontSize: 10.5,
  padding: '0 7px',
  color: 'var(--nb-subtle)',
  background: 'var(--nb-bg)',
  borderColor: 'var(--nb-border)',
} as const;

export function GiftPassBundleStatusPill({ isActive }: { isActive: boolean }) {
  if (isActive) return <StatusPill tone="active" label="Enabled" />;
  return (
    <span className="nb-pill" style={INACTIVE_STYLE}>
      <i className="nb-pill-dot" aria-hidden="true" style={{ opacity: 0.5 }} />
      Disabled
    </span>
  );
}
